import { IconSize } from '../../types/Icon';
import { dropdownIconsSizes, DropdownSize } from './constants';

export const getIndicatorSize = (
  indicatorSize: IconSize | undefined,
  size: DropdownSize,
) => {
  if (indicatorSize) {
    return indicatorSize;
  }
  if (size) {
    return dropdownIconsSizes[size];
  }
  return IconSize.DEFAULT;
};
